import allfragments from '../fragments/k8';

export const queryK8services = `query getServiceForTeamWithTotalCount(${allfragments.getServiceForTeamWithTotalCount.variable}) {${allfragments.getServiceForTeamWithTotalCount.query}}`;

export const readMetricsValuesLineChart = `query queryInstances(${allfragments.readMetricsValues.variable}) {${allfragments.readMetricsValues.query}}`;

export const k8sDashboard = `query k8sDashboard(${allfragments.k8sDashboard.variable}) {${allfragments.k8sDashboard.query}}`;

export const k8sTable = `query k8sGetTableOverview(${allfragments.k8sTable.variable}) {${allfragments.k8sTable.query}}`;

export const k8sNamespaceTable = `query k8sNamespaceTableMetrics(${allfragments.k8sNamespaceTable.variable}) {${allfragments.k8sNamespaceTable.query}}`;

export const k8sServiceInstanceCount = `query k8sServiceInstanceCount(${allfragments.k8sServiceInstanceCount.variable}) {${allfragments.k8sServiceInstanceCount.query}}`;

export const getK8InstanceByMetaProperties = `query getServiceInstancesByMetaProperties(${allfragments.getK8InstanceByMetaProperties.variable}) {${allfragments.getK8InstanceByMetaProperties.query}}`;

export const getK8MetricCardProperties = `query k8sLatestMetric(${allfragments.getK8CardsProperties.variable}) {${allfragments.getK8CardsProperties.query}}`;

export const getK8MultiChart = `query queryData(${allfragments.readAllMetricsFilteredAtServiceScopeTemplate.variable}) {${allfragments.readAllMetricsFilteredAtServiceScopeTemplate.query}}`;

export const getK8MetricsAttributes = `query k8sGetMetaProperties(${allfragments.getK8Attributes.variable}) {${allfragments.getK8Attributes.query}}`;

export const getK8AllInstances = `query k8sGetAllInstances(${allfragments.getAllK8Instances.variable}) {${allfragments.getAllK8Instances.query}}`;

export const readMetricsValuesCompare = `query queryInstances(${allfragments.readMetricsValuesCompare.variable}) {${allfragments.readMetricsValuesCompare.query}}`

export const getK8MultiChartCompare = `query queryData(${allfragments.readAllMetricsFilteredAtServiceScopeTemplateCompare.variable}) {${allfragments.readAllMetricsFilteredAtServiceScopeTemplateCompare.query}}`;
